import {version} from '../../package.json'
export const appVersion = version
